// Must run before configureStore: once Checkout mounts, an unrelated
// updateForm dispatch can erase an unclassified legacy custom tip.
export const migratePersistedState = (state: any): any => {
  const form = state?.checkout?.form
  const isLegacyCustomTip =
    form &&
    form.tip &&
    form.tipPercent === null &&
    form.tipCustomAmount === undefined
  if (!isLegacyCustomTip) return state
  return {
    ...state,
    checkout: {
      ...state.checkout,
      form: { ...form, tipCustomAmount: form.tip },
    },
  }
}
